import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminQueue(service, id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchAdminQueue() {
    setLoading(true);
    const { response, data } = await API.admin.fetchQueue(token, service, id);

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError(data.message);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchAdminQueue();
  }, [token, service, id]);

  return {
    loading,
    error,
    queue: result,
    refresh: fetchAdminQueue,
  }
}
